import { Api } from '@/interface/api';

/**
 * 首页banner
 */
const getHomeBannerList: Api = {
    url: '/api/project/proxy/api/v3/page-banners.json',
    method: 'get'
};

/**
 * 首页流程
 */
// const getHomeScheduleList: Api = {
//     url: '/api/home/page-schedule.json',
//     method: 'get'
// };

/**
 * 首页动态
 */
const getHomeInformations: Api = {
    url: '/api/project/proxy/api/informations.json',
    method: 'get'
};

/**
 * 首页直播
 */
const getHomeRaceVideo: Api = {
    url: '/api/project/proxy/api/race-video',
    method: 'get'
};

export {
    getHomeBannerList,
    // getHomeScheduleList,
    getHomeRaceVideo, 
    getHomeInformations
}
